import { Fragment, memo } from 'react';

import type { Props } from './types';

// Beyond this, drawing the gap to scale would make the whole preview
// unreadably wide (or the dots unreadably close), so the connector switches
// to a fixed-width "not to scale" dashed segment labeled with the real gap.
const COMPRESSED_GAP_THRESHOLD_WEEKS = 8;

const RepeatTimelinePreview = ({ steps, gapWeeks }: Props) => {
  if (steps.length < 2) return null;

  const isCompressed = gapWeeks > COMPRESSED_GAP_THRESHOLD_WEEKS;
  const connectorFlex = isCompressed ? '0 0 3rem' : `${Math.max(gapWeeks, 1)} 1 1.5rem`;

  return (
    <div className="flex items-start justify-center">
      {steps.map((step, index) => (
        <Fragment key={step.id}>
          <div
            className="flex flex-none flex-col items-center gap-1 text-center"
            data-testid="repeat-timeline-step">
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                step.isFirst ? 'bg-uniform-green-600' : 'bg-uniform-green-500'
              }`}
            />
            <span className="whitespace-nowrap text-[0.68rem] text-uniform-gray-600 dark:text-uniform-gray-400">
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className="flex flex-col items-center gap-0.5 pt-1"
              style={{ flex: connectorFlex }}>
              <div
                className={`h-0 w-full border-t ${
                  isCompressed
                    ? 'border-dashed border-uniform-gray-300 dark:border-uniform-gray-600'
                    : 'border-uniform-green-400 dark:border-uniform-green-600'
                }`}
              />
              {isCompressed && (
                <span className="whitespace-nowrap text-[0.6rem] text-uniform-gray-400 dark:text-uniform-gray-500">
                  {gapWeeks}w gap
                </span>
              )}
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default memo(RepeatTimelinePreview);
